<template>
  <v-container
    fluid
  >
    <v-row
      class="ma-0"
    >
      <v-btn
        color="primary"
        block
        large
        :loading="isImporting"
        @click="onImportClick"
      >
        <v-row
          justify="center"
          align="center"
          class="ma-0"
        >
          <v-icon class="mr-2">mdi-file-import</v-icon>
          Importar áreas
        </v-row>
      </v-btn>
      <input
        type="file"
        multiple
        accept=".zip,.kml"
        ref="file-input"
        @change="onFileInputChange"
        class="d-none"
      >
    </v-row>
  </v-container>
</template>

<script>
  import {forEach} from "lodash/collection"
  import {importField} from "../../../../api/api-project"
  import {FEATURE_GROUPS} from "../../../../helpers/leaflet/constants"

  const _Map = Symbol.for("_Map")
  const _Processing = Symbol.for("_Processing")

  export default {
    name: "FieldImport",
    inject: {_Map, _Processing},
    data: () => ({
      isImporting: false,
    }),
    methods: {
      onImportClick() {
        this.$refs["file-input"].click()
      },
      onFileInputChange(event) {
        this.isImporting = true
        this.importFieldsHandler(Array.from(event.target.files))
      },
      importFieldsHandler(filesArr) {
        const importFieldsPromiseList = []
        forEach(filesArr, file => {
          importFieldsPromiseList.push(
            importField(this.$apiAuth.getAuthToken(), this.Processing["id_processing"], file)
              .then(res => {
                const field = res.data.data
                window.L.HorusLeaflet.field(field, {}, this.Map, true)
                  .addTo(this.Map.featureGroups[FEATURE_GROUPS.FEATURES])
              })
          )
        })
        Promise.all(importFieldsPromiseList)
          .finally(() => {
            this.isImporting = false
            this.$refs["file-input"].value = null
          })
      },
    },
    computed: {
      Map() {
        return this._Map()
      },
      Processing() {
        return this._Processing()
      },
    },
  }
</script>

<style scoped lang="scss">

</style>
